import { isInfomat } from "../API/URLS";
import Store from "../Stores/Store";

const url = getInfomatURL();

function getInfomatURL() {
  const paramUrl = new URL(document.location).searchParams.get("url");
  const paramQServerUrl = new URL(document.location).searchParams.get(
    "qServerUrl"
  );
  return `${paramUrl}&qServerUrl=${paramQServerUrl}`;
}

export function inputFocusMessage(command) {
  const message = {};
  if (command === "openNumKeyboard") {
    message.command = "openNumKeyboard";
  } else if (command === "openKeyboard") {
    message.command = "openKeyboard";
  } else if (command === "closeKeyboard") {
    message.command = "closeKeyboard";
  }
  if (isInfomat) {
    window.parent.postMessage(JSON.stringify(message), url);
  }
}

export function closeIframeMessage() {
  const message = {
    command: "close",
  };
  if (isInfomat) {
    window.parent.postMessage(JSON.stringify(message), url);
  }
}

export function resetTimerMessage() {
  const message = {
    command: "resetTimer",
  };
  if (isInfomat) {
    window.parent.postMessage(JSON.stringify(message), url);
  }
}

export function paymentMessage() {
  const message = {
    command: "pay",
    data: Store.payment.terminalPaymentInfo,
  };
  if (isInfomat) {
    window.parent.postMessage(JSON.stringify(message), url);
  }
}
